var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4987 17.5009H10.8321M2.08203 17.9176L6.70642 16.139C7.00221 16.0252 7.1501 15.9683 7.28846 15.894C7.41137 15.8281 7.52853 15.7519 7.63873 15.6664C7.7628 15.5701 7.87484 15.4581 8.09893 15.234L17.4987 5.83424C18.4192 4.91376 18.4192 3.42138 17.4987 2.5009C16.5782 1.58043 15.0859 1.58043 14.1654 2.5009L4.7656 11.9007C4.54151 12.1248 4.42947 12.2368 4.33319 12.3609C4.24768 12.4711 4.17153 12.5882 4.10556 12.7111C4.03129 12.8495 3.97441 12.9974 3.86064 13.2932L2.08203 17.9176ZM2.08203 17.9176L3.79713 13.4584C3.91986 13.1393 3.98123 12.9797 4.08648 12.9066C4.17846 12.8428 4.29228 12.8186 4.40228 12.8396C4.52814 12.8637 4.64902 12.9845 4.89077 13.2263L6.77334 15.1089C7.01509 15.3506 7.13597 15.4715 7.16 15.5973C7.18101 15.7073 7.15685 15.8212 7.09299 15.9131C7.0199 16.0184 6.86035 16.0798 6.54126 16.2025L2.08203 17.9176Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7e6a44df970409e92318bcf8fed3fa6d.svg";
export { ForwardRef as ReactComponent };